/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { ClientSDK } from "../lib/sdks.js";
import { ActorAttributes } from "./actorattributes.js";
import { Events } from "./events.js";
import { GramOverview } from "./gramoverview.js";
import { GramRules } from "./gramrules.js";

export class SpendRules extends ClientSDK {
  private _rules?: GramRules;
  get rules(): GramRules {
    return (this._rules ??= new GramRules(this._options));
  }

  private _overview?: GramOverview;
  get overview(): GramOverview {
    return (this._overview ??= new GramOverview(this._options));
  }

  private _actorAttributes?: ActorAttributes;
  get actorAttributes(): ActorAttributes {
    return (this._actorAttributes ??= new ActorAttributes(this._options));
  }

  private _events?: Events;
  get events(): Events {
    return (this._events ??= new Events(this._options));
  }
}
